import axios from 'axios';
import config from '../config';

export const createSystemConfiguration = (configuration: any) => {
    return axios.post(`${config.API_URL}/system/configurations`, configuration).then((response: any) => {
        return response.data.message;
    });
};
